// AUTO-GENERATED FILE — DO NOT EDIT. Run `bazel run settings-registry`.
//
// Regenerate with `bazel run settings-registry`.

import type { SettingsWrapperManifest } from "./settings-wrapper-manifest.types";

export const settingsWrapperManifest: SettingsWrapperManifest = {
  sections: [
    {
      id: "advanced-coverage",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "checkout-ui-customizations",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "commentsold-coverage",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "customer_widget.appearance",
      page: "/settings/customer-widget",
      file: "customer-widget/tabs/general-tab.tsx",
    },
    {
      id: "display",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "display-options",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "dynamic-coverage-transform",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "exclusions",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "general-coverage",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "pre-protected-orders",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "redo-item-fulfillment",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "return-coverage",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "sales-channels",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "shopify-cart-validation",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "support.live_chat_widget",
      page: "/settings/customer-widget",
      file: "customer-widget/tabs/support-tab.tsx",
    },
  ],
  settings: [
    {
      id: "advanced-options",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "cart-validation-function",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "channel-selector",
      page: "/settings/coverage/sales-channels-card",
      file: "coverage/sales-channels-card.tsx",
    },
    { id: "color", page: "/settings/coverage", file: "coverage/coverage.tsx" },
    {
      id: "couponed-items-threshold",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "coverage-builder",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "display",
    },
    {
      id: "covered-return-methods",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "custom-logo",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "display",
    },
    {
      id: "customerWidget/general/hideWidgetAfterHours",
      page: "/settings/customer-widget",
      file: "customer-widget/tabs/support-tab.tsx",
      sectionId: "support.live_chat_widget",
    },
    {
      id: "customerWidget/general/widgetColor",
      page: "/settings/customer-widget",
      file: "customer-widget/tabs/general-tab.tsx",
      sectionId: "customer_widget.appearance",
    },
    {
      id: "customerWidget/support/messagingHeadingText",
      page: "/settings/customer-widget",
      file: "customer-widget/tabs/support-tab.tsx",
      sectionId: "support.live_chat_widget",
    },
    {
      id: "delete-cart-properties",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "dynamic-coverage-transform-function",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "exclude-cent-endings",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "exclude-collections",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "exclude-customer-tags",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "exclude-discount-codes",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "exclude-in-store-pickup",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "general-coverage",
    },
    {
      id: "exclude-local-pickup",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "exclude-order-tags",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "exclude-product-tags",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "exclude-properties",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "exclude-skus",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "exclude-sources",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "exclude-variant-metafields",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "final-sale-returns-coverage",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "final-sale-subtext",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "final-sale-title-text",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "font-size",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "info-modal",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "display",
    },
    {
      id: "info-text",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "make-sale-items-ineligible",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "pre-protected-orders",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "pre-protected-orders",
    },
    {
      id: "redo-item-fulfillment",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "redo-item-fulfillment",
    },
    {
      id: "require-exact-match",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "exclusions",
    },
    {
      id: "show-on-product-page",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
      sectionId: "general-coverage",
    },
    {
      id: "spacing",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "subtext-size",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
    {
      id: "title-text-size",
      page: "/settings/coverage",
      file: "coverage/coverage.tsx",
    },
  ],
};
